import type { IconNames } from '@dixa/lib-shared-habla';

import { FlowNode, flowNodeColor, NodeTypeComponent } from 'fable/flowEditor';
import type { NodeT } from 'fable/flowEditor';
import { AutomationNodeTypes } from 'hocs';

import { noModal } from '../modals';
import type { AutomationFlowExtraDataT } from '../types';

export type AutomationNodeStopPayloadT = {};
export type AutomationNodeStopTypeT = AutomationNodeTypes.STOP;
export type AutomationNodeStopT = NodeT<
  AutomationNodeStopTypeT,
  AutomationNodeStopPayloadT
>;

export class StopNode extends NodeTypeComponent<
  AutomationNodeStopT,
  AutomationFlowExtraDataT
>() {
  static icon: IconNames = 'close';
  static label = 'End automation';
  static color = flowNodeColor.red;
  static ActionModal = noModal<AutomationNodeStopT>(AutomationNodeTypes.STOP);
  static actionTrigger = { type: AutomationNodeTypes.STOP };
  static updateConnection = (
    node: AutomationNodeStopT,
  ): AutomationNodeStopT => {
    return node;
  };

  render() {
    return (
      <FlowNode
        color={StopNode.color}
        icon={StopNode.icon}
        label={StopNode.label}
      />
    );
  }
}
